module.exports = __webpack_public_path__ + "static/media/colicoli9.3ad19a3d.webp";